import { EmailPreferences, SharedEmailPreferences, User } from 'types/User'
import AolPreference from './AolPreference'
import EmailPreferencesForm from './EmailPreferencesForm'
import PageHeader from '../PageHeader'
import PrimaryAolSelector from './PrimaryAolSelector'
import PractisingAolSelector from './PractisingAolSelector'
import { AOL_MODAL_ENABLED, SHARED_EMAIL_PREFS } from 'constants/feature-flags'

type AolPreferencesProps = Pick<User, 'accessRoles'> & {
  preferences: EmailPreferences | SharedEmailPreferences
  primaryAol: string
}

export default function AolPreferences ({ accessRoles, preferences, primaryAol }: AolPreferencesProps): JSX.Element {
  return (
    <>
      <PageHeader margin='my6' title='Primary practice area' />
      <PrimaryAolSelector primaryAol={primaryAol} />
      {AOL_MODAL_ENABLED && <PractisingAolSelector />}
      <PageHeader margin='my6' title='News email preferences' />
      {
        SHARED_EMAIL_PREFS
          ? <EmailPreferencesForm accessRoles={accessRoles} preferences={preferences as SharedEmailPreferences} />
          : (Object.keys(preferences) as Array<keyof EmailPreferences>)
              .filter((key) => accessRoles.some(accessRole => accessRole.match(`${key}_news`)))
              .map((key) => <AolPreference key={`${key}-email-preferences`} aolPreference={(preferences as EmailPreferences)[key]} />)
      }
    </>
  )
}
